module.exports = __webpack_public_path__ + "static/img/1.bf54658.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/1.png
// module id = cFwg
// module chunks = 0